<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.comparisonstatistics')"
            ></head-menu>

            <div class="row">
              <div class="col-12">
                <div class="block br-t-l-0 w-100-p br-t-l-xl-0 p-3">

                  <!-- Jahresauswahl -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <h5>{{ $t('global.years') }}</h5>
                      <div v-if="loadingJahre" class="text-muted">
                        {{ $t('global.loading') }}...
                      </div>
                      <div v-else class="d-flex flex-wrap">
                        <div
                          v-for="jahr in verfuegbareJahre"
                          :key="jahr"
                          class="form-check mr-4 mb-2"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'jahr-' + jahr"
                            :value="jahr"
                            v-model="selectedJahre"
                          />
                          <label class="form-check-label" :for="'jahr-' + jahr">
                            {{ jahr }}
                          </label>
                        </div>
                      </div>
                      <small v-if="selectedJahre.length === 0" class="text-danger">
                        {{ $t('global.selectminone') }}
                      </small>
                    </div>
                  </div>

                  <!-- Statistikauswahl -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <h5>Statistiken</h5>
                      <div class="d-flex flex-column">
                        <div class="form-check mb-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="stat-kanton"
                            value="per_kanton_status"
                            v-model="selectedSheets"
                          />
                          <label class="form-check-label" for="stat-kanton">
                            Einsätze nach Kanton &amp; Status
                          </label>
                        </div>
                        <div class="form-check mb-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="stat-sprachregion"
                            value="per_sprachregion_status"
                            v-model="selectedSheets"
                          />
                          <label class="form-check-label" for="stat-sprachregion">
                            Einsätze nach Sprachregion &amp; Status
                          </label>
                        </div>
                        <div class="form-check mb-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="stat-herkunft"
                            value="per_herkunft_status"
                            v-model="selectedSheets"
                          />
                          <label class="form-check-label" for="stat-herkunft">
                            JUG nach Herkunft (Inland/Ausland) &amp; Status
                          </label>
                        </div>
                      </div>
                      <small v-if="selectedSheets.length === 0" class="text-danger">
                        {{ $t('global.selectminone') }}
                      </small>
                    </div>
                  </div>

                  <!-- Export Button -->
                  <div class="row">
                    <div class="col-12">
                      <button
                        class="btn btn-primary"
                        @click="exportExcel"
                        :disabled="loading || selectedJahre.length === 0 || selectedSheets.length === 0"
                      >
                        <font-awesome-icon
                          v-if="loading"
                          icon="fa-solid fa-spinner"
                          spin
                          class="mr-2"
                        />
                        <font-awesome-icon
                          v-else
                          icon="fa-solid fa-file-excel"
                          class="mr-2"
                        />
                        Excel exportieren
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import FileDownload from "js-file-download";
import ExportApi from "@/api/ExportApi";
import Navbar from "@/components/Navbar.vue";
import HeadMenu from "@/components/HeadMenu.vue";
import page from "@/mixins/Page";
import store from "@/store";

export default {
  name: "Vergleichsstatistik",
  components: {
    Navbar,
    HeadMenu,
  },
  metaInfo() {
    return {
      titleTemplate: () => "BX: Vergleichsstatistik",
    };
  },
  mixins: [page],
  store,
  data() {
    return {
      verfuegbareJahre: [],
      selectedJahre: [],
      selectedSheets: ["per_kanton_status", "per_sprachregion_status", "per_herkunft_status"],
      loadingJahre: true,
      loading: false,
    };
  },
  mounted() {
    this.ladeJahre();
  },
  methods: {
    ladeJahre() {
      this.loadingJahre = true;
      ExportApi.get("/excel/vergleichsstatistik-jahre")
        .then((response) => {
          this.verfuegbareJahre = response.data || [];
          // Standardmässig die letzten 3 Jahre vorauswählen
          this.selectedJahre = this.verfuegbareJahre.slice(0, 3);
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: "Fehler",
            text: "Jahre konnten nicht geladen werden.",
          });
        })
        .finally(() => {
          this.loadingJahre = false;
        });
    },

    exportExcel() {
      if (this.selectedJahre.length === 0 || this.selectedSheets.length === 0) return;

      this.loading = true;
      const payload = {
        jahre: [...this.selectedJahre].sort(),
        selectedSheets: this.selectedSheets,
      };

      ExportApi.post("/excel/vergleichsstatistik", payload, {
        responseType: "blob",
      })
        .then((response) => {
          const date = new Date().toLocaleDateString("de-CH");
          FileDownload(response.data, `Vergleichsstatistik_${date}.xlsx`);
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: "Export fehlgeschlagen",
            text: "Fehler beim Erstellen der Excel-Datei.",
            duration: 7000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
